export default __webpack_public_path__ + "static/media/Jee(Mains)-Exam.3bdd7865.png";